import { type IPrivateContactLead } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IPrivateContactLeadState } from './types';

export const GET_FROM_CONTACT = 'getFromContact';
export const GET_FROM_LEAD = 'getFromLead';
export const GET_FROM_CONTACT_AND_LEAD = 'getFromContactAndLead';

const getPrivateContactLead = (_state: IPrivateContactLeadState, ids = [] as number[]): IPrivateContactLead[] => {
    return ids
        .map((privateContactLeadId: number) => {
            return _state.dataObjectList.get(privateContactLeadId);
        })
        .filter((privateContactLead) => {
            return privateContactLead;
        });
};

export const getters: GetterTree<IPrivateContactLeadState, unknown> = {
    [GET_FROM_LEAD]: (_state: IPrivateContactLeadState) => {
        return (leadId: number): IPrivateContactLead[] | undefined => {
            return getPrivateContactLead(_state, _state.byLead.get(leadId) ?? []);
        };
    }
};
